import EducationItem from '../../../../../../components/Cards/CardComponents/EducationItem'
import { Education } from '../../../../../../types/education'

interface EducationSectionProps {
  education: Education[]
}

export function EducationSection({ education }: EducationSectionProps) {
  if (!education?.length) return null

  return (
    <div className="tc-mv-question-field p-4 rounded-2xl text-white space-y-2">
      <h2 className="text-xl font-semibold">Education</h2>
      <div className="space-y-8">
        {education.map((edu, index) => (
          <EducationItem key={index} education={edu} />
        ))}
      </div>
    </div>
  )
}
